import { withAIOpsDomainPrefix } from '@atlassian/aiops-common';
import { fetch } from '@atlassian/eoc-fetch';

export const getGroupCustomizationFeatureState = (): Promise<{
	isEnabled: boolean;
}> => {
	return fetch<{
		isEnabled: boolean;
	}>(withAIOpsDomainPrefix('/v1/aiops/feature-state?featureName=alert-group-customization'), {
		exactUrl: true,
	});
};
